import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PortalAccountsTable from './portal-accounts-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-portal-admin-subcontractors')) {
  ReactDOM.render(<PortalAccountsTable
    url= "/api/v1/portal/portal-admin/portal-subcontractors"
    message_if_none = 'No subcontractor accounts in system yet.'
  />,
document.getElementById('react-component-g4-logistics-portal-portal-admin-subcontractors'));
}
